import { makeStyles } from "@material-ui/core";
import { useIO, useLinked } from "@type-r/react";
import DOMPurify from "dompurify";
import { asDate, CollapsableSection, Column, Columns, FormInput, Link, Loading } from 'lqx-react';
import React, { useEffect, useRef } from "react";
import { EmailInfo, execGetRAFile, FileRef } from "../api/remittance-advice";

export const ViewEmail = ({emailInfo} : {
    emailInfo: EmailInfo
}) => {
    const classes = useTextStyles();

    const $doIO = useLinked(null);    
    const isReady = useIO(
        async () => $doIO.value && await getFile($doIO.value),
        [ $doIO.value ]
    );
    const getFile = async (attachment : FileRef) => {
        const response = await execGetRAFile(attachment.url);
        if (response && response.status === 200) {
            const blob = await response.blob();

            const dataUrl = window.URL.createObjectURL(blob),
                a = document.createElement('a');

            a.href = dataUrl;
            a.download = attachment.name;
            document.body.appendChild(a);
            a.click();
            a.remove();
        }
    }

    const iframe = useRef(null);
    useEffect(() => {
        if (iframe.current && emailInfo.messageBodyHtml) {
            const mailContent = DOMPurify.sanitize(emailInfo.messageBodyHtml, {FORBID_TAGS: ['img']});

            iframe.current.contentDocument.write(mailContent);
            iframe.current.height = iframe.current.contentDocument.body.scrollHeight;
        }
    }, [emailInfo.messageBodyHtml]);

    return (
        <CollapsableSection title="Email">
            <Columns>
                <Column>
                    <FormInput readOnly label="Subject" value={emailInfo.subject} />
                    <FormInput readOnly label="From" value={emailInfo.from} />
                </Column>
                <Column>
                    <FormInput readOnly label="Date" value={asDate(emailInfo.sentDate)} />
                    <FormInput label="To" readOnly value={emailInfo.to} />
                </Column>
            </Columns>
            <Columns>
                <Column>
                {emailInfo.attachments.length ?
                    <div className={classes.root}>
                        <span>Attachements</span>
                        { isReady ? 
                            emailInfo.attachments.map( attachment =>
                                <span className={classes.attachementLink}>
                                    <Link key={attachment.name}
                                        onClick={() => $doIO.set(attachment)}
                                    >
                                        {attachment.name}
                                    </Link>
                                </span>
                            )
                        :
                            <Loading />
                        }
                    </div> : undefined }
                </Column>
            </Columns>
            <iframe ref={iframe} frameBorder="0" scrolling="false"></iframe>
        </CollapsableSection> );
}

const useTextStyles = makeStyles({
    root : {
        display: 'flex',
        flexDirection: 'row',
        color: '#767D84',
        fontFamily: 'Montserrat',
        fontSize: 12,
        fontWeight: 500,
        flexWrap: 'wrap'
    },

    attachementLink: {
        paddingLeft: 10,
    },
});
